import { Card, Space, TextLoader } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { HeroImagePlaceholderStyled } from './styles/ChangelogReleaseListLoaderStyled'
import messages from '../ChangelogReleaseList/messages'
import { ChangelogReleaseStyled } from '../ChangelogReleaseList/styles/ChangelogReleaseStyled'

export interface IChangelogReleaseListLoaderProps {
  /** Placeholder rows — matches the release count the tab will show. */
  count: number
}

export const ChangelogReleaseListLoader = ({
  count,
}: IChangelogReleaseListLoaderProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space size='medium' aria-busy>
      {Array.from({ length: count }, (_, index) => (
        <Card key={index}>
          <Card.Content>
            <ChangelogReleaseStyled>
              <HeroImagePlaceholderStyled
                aria-label={
                  index === 0
                    ? intl.formatMessage(messages.loadingLabel)
                    : undefined
                }
              />
              <Space size='small'>
                <TextLoader width='40%' />
                <TextLoader width='75%' height={20} />
                <TextLoader />
                <TextLoader width='85%' />
              </Space>
            </ChangelogReleaseStyled>
          </Card.Content>
        </Card>
      ))}
    </Space>
  )
}

ChangelogReleaseListLoader.displayName = 'ChangelogReleaseListLoader'
